import React from "react";
import "./Loading.css";
import { CircularProgress } from "@material-ui/core";

const Loading = (props) => {
  const show = props.show ?? false;
  if (show) {
    return (
      <div className="t-loading loading-wrapper">
        <div className="loading-lightbox">
          <CircularProgress
            classes={{ root: "tui-loading" }}
            color={props.color}
            size={props.size}
            thickness={props.thickness}
          />
        </div>
      </div>
    );
  } else return <></>;
};

export default Loading;
